module.exports = __webpack_public_path__ + "static/media/logo_yupoints.417e1e8b.png";